import { Form } from '../forms/Form';
import { Enrollment, EnrollmentDto } from './Enrollment';
import { utilities } from 'utils/utilities';

export interface FormEnrollmentDto extends EnrollmentDto {
  formId: string;
}

export class FormEnrollment extends Enrollment {
  form: Form;
  readonly type: 'Models.Enrollments.FormEnrollment' = 'Models.Enrollments.FormEnrollment';

  constructor(id: string, form: Form) {
    super(id);
    this.form = form;
  }

  toDto(): FormEnrollmentDto {
    return {
      formId: this.form.id,
      id: this.id,
      enrollmentType: this.type,
      dtoType: 'Models.Api.Dtos.FormEnrollmentDto'
    };
  }

  static fromDto(dto?: Partial<FormEnrollmentDto> | FormEnrollment | any): FormEnrollment {
    console.log("FormEnrollment DTO " + JSON.stringify(dto));
    if (!dto) {
      // create a minimal stub form with only id so toDto still works
      return new FormEnrollment(utilities.DEFAULT_GUID, { id: utilities.DEFAULT_GUID } as any);
    }

    if (dto instanceof FormEnrollment) {
      return dto;
    }

    const id = dto.id ?? utilities.DEFAULT_GUID;
    const formId = (dto as FormEnrollment).form.id ?? (dto as FormEnrollmentDto).formId ?? utilities.DEFAULT_GUID;
    // We don't have full form data here; create a minimal Form stub with id so callers can access form.id
    const formStub = { id: formId } as any as Form;
    return new FormEnrollment(id, formStub);
  }
}

// Register factory to avoid Enrollment needing a hard import (prevents circular init issues)
Enrollment.register('Models.Enrollments.FormEnrollment', (d?: any) => FormEnrollment.fromDto(d));
